const C_ASSOCIATES_TYPES = {
  NINGUNO: {
    label: "Ninguno",
    value: "Ninguno",
    name: "Ninguno",
    id: 0
  },
  NO_BROKER: {
    label: "No-broker",
    value: "No-broker",
    name: "No-broker",
    id: 1
  },
  CO_BROKER: {
    label: "Co-broker",
    value: "Co-broker",
    name: "Co-broker",
    id: 0
  }
};

const O_ASSOCIATES_TYPES = {
  [C_ASSOCIATES_TYPES.NO_BROKER.label]: C_ASSOCIATES_TYPES.NO_BROKER,
  [C_ASSOCIATES_TYPES.CO_BROKER.label]: C_ASSOCIATES_TYPES.CO_BROKER,
  [C_ASSOCIATES_TYPES.NO_BROKER.value]: C_ASSOCIATES_TYPES.NO_BROKER,
  [C_ASSOCIATES_TYPES.CO_BROKER.value]: C_ASSOCIATES_TYPES.CO_BROKER,
  [C_ASSOCIATES_TYPES.NO_BROKER.name]: C_ASSOCIATES_TYPES.NO_BROKER,
  [C_ASSOCIATES_TYPES.CO_BROKER.name]: C_ASSOCIATES_TYPES.CO_BROKER,
  [C_ASSOCIATES_TYPES.NO_BROKER.id]: C_ASSOCIATES_TYPES.NO_BROKER,
  [C_ASSOCIATES_TYPES.CO_BROKER.id]: C_ASSOCIATES_TYPES.CO_BROKER
};

const A_ASSOCIATES_TYPES = [
  C_ASSOCIATES_TYPES.NINGUNO,
  C_ASSOCIATES_TYPES.NO_BROKER,
  C_ASSOCIATES_TYPES.CO_BROKER
];

export { C_ASSOCIATES_TYPES, O_ASSOCIATES_TYPES, A_ASSOCIATES_TYPES };
